import moment from "moment";

export const formatDateConsultation = (date) => {
  date = `${moment(date).format("ddd, MMM DD, hh:mm A")} - ${moment(date)
    .add(2, "hours")
    .format("hh:mm A")}`;
  return date;
};
